// Wave UX-2.3 #19 (2026-05-23) — 차량 사진 fullscreen viewer.
// AuctionDetail 사진 클릭 → modal 진입. ESC / backdrop click 으로 닫기.
// 사용:
//   <PhotoViewerModal auctionId={5} count={N} startIdx={0} onClose={...} />

import React, { useState, useEffect } from 'react';
import AuthImage from './AuthImage';
import { useT } from '../../i18n/I18nProvider';

function PhotoViewerModal(props) {
  var t = useT();
  var auctionId = props.auctionId;
  var count = props.count || 0;
  var [idx, setIdx] = useState(props.startIdx || 0);

  useEffect(function() {
    function onKey(e) {
      if (e.key === 'Escape') { props.onClose && props.onClose(); return; }
      if (e.key === 'ArrowLeft') { setIdx(function(i){ return (i - 1 + count) % count; }); return; }
      if (e.key === 'ArrowRight') { setIdx(function(i){ return (i + 1) % count; }); return; }
    }
    window.addEventListener('keydown', onKey);
    return function() { window.removeEventListener('keydown', onKey); };
  }, [count, props]);

  if (count <= 0) return null;

  function prev(e) { e.stopPropagation(); setIdx((idx - 1 + count) % count); }
  function next(e) { e.stopPropagation(); setIdx((idx + 1) % count); }

  // pathBase 지정 시 그것 사용(전체매물 등), 미지정 시 경매 사진 경로 (기존 호출 호환).
  var path = (props.pathBase || ('/buyer-app/auction/' + auctionId)) + '/photo/' + idx;

  return (
    <div onClick={props.onClose}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.92)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 2000,
      }}>

      {/* close 버튼 */}
      <button type="button" onClick={function(e){ e.stopPropagation(); props.onClose && props.onClose(); }}
        title={t('photoClose')}
        style={{
          position: 'absolute', top: 20, right: 20,
          width: 44, height: 44, borderRadius: '50%',
          background: 'rgba(255,255,255,0.12)', color: 'white',
          border: 'none', fontSize: 22, fontWeight: 700,
          cursor: 'pointer', zIndex: 2,
        }}>×</button>

      {/* counter */}
      {count > 1 && (
        <span style={{
          position: 'absolute', top: 28, left: '50%', transform: 'translateX(-50%)',
          background: 'rgba(255,255,255,0.12)', color: 'white',
          padding: '6px 14px', borderRadius: 999,
          fontSize: 13, fontWeight: 700, zIndex: 2,
        }}>{t('photoCounter', { n: idx + 1, total: count })}</span>
      )}

      {/* main image */}
      <div onClick={function(e){ e.stopPropagation(); }}
        style={{ width: '92%', height: '88%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AuthImage path={path}
          alt=""
          style={{
            maxWidth: '100%', maxHeight: '100%',
            objectFit: 'contain', display: 'block',
          }}
        />
      </div>

      {/* prev/next */}
      {count > 1 && (
        <>
          <button type="button" onClick={prev}
            title={t('photoPrev')}
            style={navBtn('left')}>‹</button>
          <button type="button" onClick={next}
            title={t('photoNext')}
            style={navBtn('right')}>›</button>
        </>
      )}
    </div>
  );
}

function navBtn(side) {
  return {
    position: 'absolute',
    [side]: 24,
    top: '50%', transform: 'translateY(-50%)',
    width: 52, height: 52,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.12)', color: 'white',
    border: 'none', fontSize: 32, fontWeight: 700,
    cursor: 'pointer', zIndex: 2,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 0, lineHeight: 1,
  };
}

export default PhotoViewerModal;
